module.exports = __webpack_public_path__ + "static/media/e4.3f368a21.jpg";